import React from 'react';
import withView from '../../cmn/docAutomation/withView';
import SarasTrans from '../../../library/notifications/SarasTrans';
import FormButton from '../../../library/form/components/FormActionButton2';
import FormROValue from '../../../library/form/components/FormROValue1';
import FormLabel from '../../../library/form/components/FormLabel'
import FormTitle from '../../../library/form/components/FormTitle';
import { UiView, UiViewHeading, UiTitle, UiAction, UiViewContent, UiGridColOne, UiCol } from "../../../library/layout/Index";

const InvTrnTermsViewer = (props) => {
    const { formObject } = props;

    return (

        <UiView>
            <UiViewHeading>
                <UiTitle>
                    <span>
                        <FormTitle formObject={formObject} value='Terms' />
                    </span>
                </UiTitle>

                <UiAction>
                    <FormButton formObject={formObject} ksc="t" rowKey=""
                        starIcon={"edit"}
                        action={{ actionId: "edit",  actionParam: {}, containerKey: "popup" }}
                        className="uiActionIconButton" text={<SarasTrans value="Edit" />}></FormButton>
                </UiAction>
            </UiViewHeading>
            <UiViewContent>
                <UiGridColOne>
                    <UiCol>
                        <ul>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "paymentTerms" }} value="Payment Terms" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "paymentTerms" }} className='uiVal' />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "paymentMode" }} value="Payment Mode" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "paymentMode" }} className='uiVal' />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "creditDays" }} value="Credit Days" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "creditDays" }} className='uiVal' />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "graceDays" }} value="Grace Days" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "graceDays" }} className='uiVal' />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "payDate" }} value="Payment Date" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "payDate" }} className='uiVal' />
                            </li>
                        </ul>
                    </UiCol>
                    <UiCol>
                        <ul style={{display:'none'}}>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "TransMode" }} value="Transport Mode" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "TransMode" }} className='uiVal' />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "delDate" }} value="Delivery Date" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "delDate" }} className='uiVal' />
                            </li>
                        </ul>
                    </UiCol>
                </UiGridColOne>
            </UiViewContent>
        </UiView>
    )
}

export default withView(InvTrnTermsViewer, "invTrnTerms", "")
